<template>
  <div>
    <CRow class="content-fade-in sim-lot-header">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol xs="12" sm="12" md="12" xl="12" class="mb-3">
                  <div style="float: right">
                    <CButton v-if="isUpdate" color="info" class="btn-action-primary mr-2"
                      @click="$refs.quickImport.open({ id: $route.params.id, name: nameInput.data.model })">
                      <i class="fa fa-sign-in"></i> Tạo phiếu nhập
                    </CButton>
                    <CButton color="secondary" class="btn-action-primary mr-2" @click="$router.push('/sim-management/list.html')">
                      <i class="fa fa-reply"></i> Quay lại
                    </CButton>
                    <CButton color="primary" class="btn-action-primary" @click="submitData()">
                      <i class="fa fa-save"></i> Lưu lại
                    </CButton>
                  </div>
                </CCol>
                <CCol xs="12" sm="12" md="4" xl="4">
                  <BaseInput :options="nameInput.options" :data="nameInput.data" />
                </CCol>
                <CCol xs="12" sm="12" md="4" xl="4">
                  <div class="form-group">
                    <label>Ngày nhập <span class="required">*</span></label>
                    <DatePicker
                      v-model="importDateValue"
                      locale="vi"
                      class="datepicker"
                      :masks="{ input: 'DD/MM/YYYY', data: 'DD/MM/YYYY' }"
                      :popover="{ visibility: 'click', positionFixed: true }"
                    >
                      <template v-slot="{ inputValue, inputEvents }">
                        <input class="form-control" :value="inputValue" v-on="inputEvents" placeholder="dd/MM/yyyy" readonly />
                      </template>
                    </DatePicker>
                    <div class="valid-error" v-show="!importDateInput.data.validator.isValid">
                      {{ importDateInput.data.validator.errorMessage }}
                    </div>
                  </div>
                </CCol>
                <CCol xs="12" sm="12" md="4" xl="4">
                  <BaseInput :options="sourceInput.options" :data="sourceInput.data" />
                </CCol>
                <CCol xs="12" sm="12" md="12" xl="12">
                  <BaseTextArea :options="noteInput.options" :data="noteInput.data" v-model="noteInput.data.model" />
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CCard class="mt-3 sim-lot-lines">
      <CCardBody>
        <CRow class="mb-3">
          <CCol>
            <h5 class="mb-0">Danh sách sim ({{ simsField.data.model.length }})</h5>
          </CCol>
          <CCol class="text-right">
            <CButton color="secondary" class="mr-2" @click="downloadTemplate()">
              <i class="fa fa-download"></i> Tải template
            </CButton>
            <CButton color="info" class="mr-2" @click="$refs.fileInput.click()">
              <i class="fa fa-upload"></i> Import Excel
            </CButton>
            <CButton color="primary" @click="addSim()">
              <i class="fa fa-plus"></i> Thêm sim
            </CButton>
            <input ref="fileInput" type="file" accept=".xlsx,.xls" class="d-none" @change="importExcel($event)" />
          </CCol>
        </CRow>
        <div class="table-responsive">
          <table class="table table-bordered table-sm">
            <thead>
              <tr>
                <th style="width: 60px">#</th>
                <th>Ngày bắt đầu</th>
                <th>Ngày hết hạn</th>
                <th>IMEI</th>
                <th>Số điện thoại</th>
                <th>ICCID</th>
                <th>Nhà mạng</th>
                <th style="width: 70px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="simsField.data.model.length === 0">
                <td colspan="8" class="text-center">Chưa có sim. Thêm tay hoặc import từ Excel.</td>
              </tr>
              <tr v-for="(sim, index) in simsField.data.model" :key="index">
                <td>{{ index + 1 }}</td>
                <td>
                  <DatePicker
                    :value="dateValue(sim.startDate)"
                    locale="vi"
                    class="datepicker"
                    :masks="{ input: 'DD/MM/YYYY', data: 'DD/MM/YYYY' }"
                    :popover="{ visibility: 'click', positionFixed: true }"
                    @input="sim.startDate = toISO($event)"
                  >
                    <template v-slot="{ inputValue, inputEvents }">
                      <input class="form-control" :value="inputValue" v-on="isActivated(sim) ? {} : inputEvents"
                        placeholder="dd/MM/yyyy" :disabled="isActivated(sim)" readonly />
                    </template>
                  </DatePicker>
                </td>
                <td>
                  <DatePicker
                    :value="dateValue(sim.expireDate)"
                    locale="vi"
                    class="datepicker"
                    :masks="{ input: 'DD/MM/YYYY', data: 'DD/MM/YYYY' }"
                    :popover="{ visibility: 'click', positionFixed: true }"
                    @input="sim.expireDate = toISO($event)"
                  >
                    <template v-slot="{ inputValue, inputEvents }">
                      <input class="form-control" :value="inputValue" v-on="isActivated(sim) ? {} : inputEvents"
                        placeholder="dd/MM/yyyy" :disabled="isActivated(sim)" readonly />
                    </template>
                  </DatePicker>
                </td>
                <td><input type="text" class="form-control" v-model="sim.imei" maxlength="32" /></td>
                <td><input type="text" class="form-control" v-model="sim.phone" maxlength="20" /></td>
                <td><input type="text" class="form-control" v-model="sim.iccid" maxlength="32" /></td>
                <td>
                  <select class="form-control" v-model="sim.carrier">
                    <option value="">Chọn nhà mạng</option>
                    <option v-for="item in carriers" :key="item" :value="item">{{ item }}</option>
                  </select>
                </td>
                <td class="text-center">
                  <CButton color="danger" variant="outline" size="sm" v-c-tooltip.hover="'Xóa'" @click="removeSim(index)">
                    <CIcon name="cil-trash" />
                  </CButton>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <small class="text-muted">
          Sim mới là phôi trắng: để trống ngày bắt đầu và ngày hết hạn. Khi kích hoạt mới điền đủ cả hai ngày.
          File Excel gồm 6 cột theo thứ tự: Ngày bắt đầu, Ngày hết hạn, IMEI, Số điện thoại, ICCID, Nhà mạng.
          IMEI, số điện thoại và ICCID nhập Text hoặc Number đều được. Số điện thoại có thể bắt đầu bằng 0 hoặc 84. Nhà mạng chọn Viettel, MobiFone, VinaPhone, Vietnamobile, Gmobile, Itel, Wintel hoặc Reddi.
        </small>
      </CCardBody>
    </CCard>
    <BaseFormLoading :value="loading.value"></BaseFormLoading>
    <SimQuickImport ref="quickImport"></SimQuickImport>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { DatePicker } from "v-calendar";
import BaseInput from "../base/BaseInput";
import BaseTextArea from "../base/BaseTextArea";
import BaseFormLoading from "../base/BaseFormLoading";
import SimQuickImport from "./QuickImport";

export default {
  name: "SimLotForm",
  components: { BaseInput, BaseTextArea, BaseFormLoading, SimQuickImport, DatePicker },
  notifications: {
    showSuccessMsg: { type: "success", title: "Success" },
    showErrorMsg: { type: "error", title: "Error" },
    showWarningMsg: { type: "warn", title: "warn" }
  },
  data: function () {
    let that = this;
    return {
      loading: { value: false },
      carriers: ["Viettel", "MobiFone", "VinaPhone", "Vietnamobile", "Gmobile", "Itel", "Wintel", "Reddi"],
      idField: {
        data: {
          name: "id",
          model: that.$route.params.id || null
        }
      },
      nameInput: {
        options: {
          label: "Tên lô sim <span class='required'>*</span>",
          placeholder: "Tên lô sim",
          maxlength: 255
        },
        data: {
          name: "name",
          model: "",
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.nameInput.data.model;
              if (!value || value.trim() === "") {
                this.isValid = false;
                this.errorMessage = "Tên lô sim không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      importDateInput: {
        data: {
          name: "importDate",
          model: moment().format("YYYY-MM-DD"),
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.importDateInput.data.model;
              if (!value) {
                this.isValid = false;
                this.errorMessage = "Ngày nhập không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      sourceInput: {
        options: {
          label: "Nhập từ <span class='required'>*</span>",
          placeholder: "Nhà cung cấp, đại lý, cửa hàng...",
          maxlength: 255
        },
        data: {
          name: "source",
          model: "",
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.sourceInput.data.model;
              if (!value || value.trim() === "") {
                this.isValid = false;
                this.errorMessage = "Nhập từ không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      noteInput: {
        options: {
          label: "Ghi chú lô sim",
          placeholder: "Ghi chú",
          maxlength: 1000,
          rows: 3
        },
        data: {
          name: "note",
          model: "",
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              this.isValid = true;
              this.errorMessage = "";
              return true;
            }
          }
        }
      },
      simsField: {
        data: {
          name: "sims",
          model: []
        }
      },
      removeSimIdsField: {
        data: {
          name: "removeSimIds",
          model: []
        }
      }
    };
  },
  computed: {
    isUpdate() {
      return !!this.$route.params.id;
    },
    importDateValue: {
      get() {
        return this.dateValue(this.importDateInput.data.model);
      },
      set(value) {
        this.importDateInput.data.model = this.toISO(value);
      }
    }
  },
  methods: {
    emptySim() {
      return { id: null, startDate: "", expireDate: "", imei: "", phone: "", iccid: "", carrier: "" };
    },
    addSim() {
      this.simsField.data.model.push(this.emptySim());
    },
    removeSim(index) {
      const sim = this.simsField.data.model[index];
      if (sim && sim.id) {
        this.removeSimIdsField.data.model.push(sim.id);
      }
      this.simsField.data.model.splice(index, 1);
    },
    formatInputDate(value) {
      if (!value) {
        return "";
      }
      const parsed = moment(value);
      return parsed.isValid() ? parsed.format("YYYY-MM-DD") : "";
    },
    dateValue(value) {
      if (!value) {
        return null;
      }
      if (value instanceof Date) {
        return new Date(value.getFullYear(), value.getMonth(), value.getDate());
      }
      if (typeof value === "string" && value.indexOf("-") === 4) {
        const parts = value.substring(0, 10).split("-");
        return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
      }
      const parsed = moment(value);
      return parsed.isValid() ? parsed.toDate() : null;
    },
    toISO(value) {
      const date = this.dateValue(value);
      if (!date) {
        return "";
      }
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return date.getFullYear() + "-" + month + "-" + day;
    },
    isActivated(sim) {
      return !!(sim && sim.startDate && sim.expireDate);
    },
    validateSims() {
      const sims = this.simsField.data.model;
      const messages = [];
      const imeiSet = {};
      const iccidSet = {};
      for (let i = 0; i < sims.length; i++) {
        const sim = sims[i];
        const row = i + 1;
        const hasStart = !!sim.startDate;
        const hasExpire = !!sim.expireDate;
        if (hasStart !== hasExpire) {
          messages.push("Dòng " + row + " phải nhập cả ngày bắt đầu và ngày hết hạn, hoặc để trống nếu là phôi");
        } else if (hasStart && sim.expireDate < sim.startDate) {
          messages.push("Dòng " + row + " ngày hết hạn phải sau ngày bắt đầu");
        }
        const imei = (sim.imei || "").trim();
        const phone = (sim.phone || "").trim();
        const iccid = (sim.iccid || "").trim();
        if (!imei) messages.push("Dòng " + row + " thiếu IMEI");
        if (!phone) messages.push("Dòng " + row + " thiếu số điện thoại");
        if (!iccid) messages.push("Dòng " + row + " thiếu ICCID");
        if (!sim.carrier) messages.push("Dòng " + row + " thiếu nhà mạng");
        if (imei) {
          const key = imei.toUpperCase();
          if (imeiSet[key]) messages.push("IMEI " + imei + " bị trùng");
          imeiSet[key] = true;
        }
        if (iccid) {
          const key = iccid.toUpperCase();
          if (iccidSet[key]) messages.push("ICCID " + iccid + " bị trùng");
          iccidSet[key] = true;
        }
        if (messages.length >= 8) break;
      }
      if (messages.length > 0) {
        this.showErrorMsg({ message: messages.join("; ") });
        return false;
      }
      return true;
    },
    submitData() {
      let that = this;
      if (!this.$helper.validDataSubmit(this.$data) || !this.validateSims()) {
        return;
      }
      this.simsField.data.model.forEach(function (sim) {
        if (!sim.startDate) sim.startDate = null;
        if (!sim.expireDate) sim.expireDate = null;
      });
      const isUpdate = this.isUpdate;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: isUpdate ? "/sim/update" : "/sim/create",
        dataRef: function () {
          return that.$data;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else if (isUpdate) {
            that.showSuccessMsg({ message: "Cập nhật lô sim thành công" });
            that.removeSimIdsField.data.model = [];
            that.loadData();
          } else {
            that.showSuccessMsg({ message: "Tạo lô sim thành công" });
            that.$router.push("/sim-management/" + response.data.data.id + "/update.html");
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    loadData() {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/sim/findById",
        isJsonContentType: false,
        dataSubmit: function () {
          return { id: that.$route.params.id };
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) || "Không tải được lô sim" });
            that.loading.value = false;
            return;
          }
          const data = response.data.data;
          that.idField.data.model = data.id;
          that.nameInput.data.model = data.name || "";
          that.noteInput.data.model = data.note || "";
          that.sourceInput.data.model = data.source || "";
          that.importDateInput.data.model = that.formatInputDate(data.importDate);
          that.simsField.data.model = (data.sims || []).map(function (sim) {
            return {
              id: sim.id,
              startDate: that.formatInputDate(sim.startDate),
              expireDate: that.formatInputDate(sim.expireDate),
              imei: sim.imei || "",
              phone: sim.phone || "",
              iccid: sim.iccid || "",
              carrier: sim.carrier || ""
            };
          });
          that.removeSimIdsField.data.model = [];
          that.loading.value = false;
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loading.value = false;
        }
      });
    },
    downloadTemplate() {
      let that = this;
      that.loading.value = true;
      axios.post(process.env.API_ENDPOINT + "/sim/template", {}, {
        responseType: "blob",
        headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
      }).then(function (response) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "template_danh_sach_sim.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        that.loading.value = false;
      }).catch(function () {
        that.loading.value = false;
        that.showErrorMsg({ message: "Không tải được file template" });
      });
    },
    importExcel(event) {
      const file = event.target.files && event.target.files[0];
      event.target.value = "";
      if (!file) {
        return;
      }
      let that = this;
      const formData = new FormData();
      formData.append("file", file);
      that.loading.value = true;
      axios.post(process.env.API_ENDPOINT + "/sim/import-preview", formData, {
        headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
      }).then(function (response) {
        that.loading.value = false;
        if (!that.$helper.validResponse(that.$router, response.data)) {
          that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
          return;
        }
        const imported = response.data.data || [];
        imported.forEach(function (sim) {
          that.simsField.data.model.push({
            id: null,
            startDate: that.formatInputDate(sim.startDate),
            expireDate: that.formatInputDate(sim.expireDate),
            imei: sim.imei || "",
            phone: sim.phone || "",
            iccid: sim.iccid || "",
            carrier: sim.carrier || ""
          });
        });
        that.showSuccessMsg({ message: "Đã đọc " + imported.length + " sim từ file" });
      }).catch(function (error) {
        that.loading.value = false;
        that.$helper.handleError(that.$router, error);
        that.showErrorMsg({ message: "Không đọc được file excel" });
      });
    }
  },
  mounted() {
    if (this.isUpdate) {
      this.loadData();
    }
  }
};
</script>

<style scoped>
.sim-lot-header {
  position: relative;
  z-index: 30;
}

.sim-lot-lines {
  position: relative;
  z-index: 1;
}
</style>
